"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCardAliasToFormattedCCAlias = void 0;
function transformCardAliasToFormattedCCAlias(cardAlias) {
    return cardAlias.replace(/.+(\d{2})$/, "##$1");
}
exports.transformCardAliasToFormattedCCAlias = transformCardAliasToFormattedCCAlias;
//# sourceMappingURL=transformCardAliasToFormattedCCAlias.js.map